export const DROPZONE_INPUT_ID = 'dropzone-field-id';
